module.exports = __webpack_public_path__ + "img/hiking001.4e856394.jpg";